import React, { FunctionComponent, ReactNode } from "react";

import LanguageDropDownSelector from "./layouts/dropdown/dropdown.component";
import LanguageListSelector from "./layouts/list/list.component";
import LanguageToggleSelector from "./layouts/toggle/toggle.component";

export type Language = {
    path: string;
    languageCode: string;
    language: string;
};

type Props = {
    layout: "default" | "list" | "toggle";
    variant?: string;
    languages: Language[];
    current: string;
};

const LanguageSelectorConfig: Record<
    Props["layout"],
    FunctionComponent<Omit<Props, "layout">>
> = {
    default: LanguageDropDownSelector,
    list: LanguageListSelector,
    toggle: LanguageToggleSelector,
};

const LanguageSelector = ({
    layout = "default",
    current,
    languages,
    variant,
}: Props) => {
    const Component = LanguageSelectorConfig[layout];

    return (
        <Component languages={languages} current={current} variant={variant} />
    );
};

export default LanguageSelector;
